export default {
    HEPDATAPORTAL_API_ENDPOINT: 'https://7mgar5m5th.execute-api.us-east-2.amazonaws.com/default/'
    //HEPDATAPORTAL_API_ENDPOINT: 'https://a3zo4dev91.execute-api.us-east-2.amazonaws.com/default/'
}
